import React from "react";
import "./Video.css";

const Video = () => {
  return (
    <section className="hero-video-section">
      <video className="hero-video" autoPlay loop muted playsInline>
        <source
          src="/assets/video/travel_video.mp4"
          type="video/mp4"
        />
      </video>
    </section>
  );
};

export default Video;
